// extracted by mini-css-extract-plugin
var _1 = "PostStatus-module__animateUploadProgressBarWidth--wN9gO";
var _2 = "PostStatus-module__animatedBackground--PvrmS";
var _3 = "PostStatus-module__container--vBUIR";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container" }
